module.exports = __webpack_public_path__ + "img/history.a928879d.png";